import { ApplicationInsights, SeverityLevel } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { LogLevel } from "@azure/msal-browser";

const reactPlugin = new ReactPlugin();
let appInsights: ApplicationInsights | null = null;

export const msalLoggerCallback = (level: LogLevel, message: string, containsPii: boolean) => {
    if (!appInsights) {
        return;
    }

    if (containsPii) {
        return;
    }

    let severityLevel: SeverityLevel;
    switch (level) {
        case LogLevel.Error:
            severityLevel = SeverityLevel.Error;
            break;
        // case LogLevel.Warning:
        //     severityLevel = SeverityLevel.Warning;
        //     break;
        // case LogLevel.Info:
        //     severityLevel = SeverityLevel.Information;
        //     break;
        case LogLevel.Verbose:
        default:
            severityLevel = SeverityLevel.Verbose;
            break;
    }

    // Log the message as a trace in Application Insights
    appInsights.trackTrace({
        message: `MSAL log: ${message}`,
		severityLevel,
    });
};

const initApplicationInsights = (connectionString: string) => {
	if (!connectionString || appInsights) {
		return appInsights;
	}

	try {
		appInsights = new ApplicationInsights({
			config: {
				connectionString: connectionString,
				extensions: [reactPlugin],
				enableAutoRouteTracking: true,
				disableAjaxTracking: false,
				autoTrackPageVisitTime: true,
				enableCorsCorrelation: true,
				enableRequestHeaderTracking: true,
				enableResponseHeaderTracking: true,
			},
		});

		appInsights.loadAppInsights();
	} catch (error) {
		console.error('Failed to initialize Application Insights:', error);
	}

	return appInsights;
};

// Utility functions for logging
export const logError = (error: Error, properties?: Record<string, any>) => {
	if (appInsights) {
		appInsights.trackException({
			exception: error,
			properties: {
				...properties,
			},
		});
	}
};

export const logEvent = (name: string, properties?: Record<string, any>) => {
	if (appInsights) {
		appInsights.trackEvent({
			name,
			properties: {
				...properties,
			},
		});
	}
};

export { reactPlugin, initApplicationInsights };
